import cx from 'classnames';
import type { HTMLAttributes } from 'react';
import { Card } from '@components/card/Card';
import { Icon } from '@components/icon/Icon';

import styles from './AddCard.scss';

export const AddCard = ({
  label,
  className,
  containerClassName,
  ...attrs
}: {
  label: string;
  containerClassName?: string;
} & HTMLAttributes<HTMLElement>) => (
  <Card className={cx(styles.addCard, className)} {...attrs}>
    <div className={cx(styles.container, containerClassName)}>
      <div className={styles.iconWrapper}>
        <Icon name="plus" className={styles.icon} />
      </div>
      <p>{label}</p>
    </div>
  </Card>
);
